import { createSlice } from '@reduxjs/toolkit';

// loading states reducer
const appSlice = createSlice({
  name: 'app',
  initialState: {
    isLoading: false,
    loadingMessage: '',
    showErrorModal: false,
    errorMessage: '',
  },
  reducers: {
    startLoading(state, { payload }) {
      const { message } = payload;
      state.isLoading = true;
      state.loadingMessage = message;
    },

    finishLoading(state, { payload }) {
      const { success, error } = payload;
      state.isLoading = false;
      state.loadingMessage = '';
      if (!success) {
        state.showErrorModal = true;
        state.errorMessage = error;
      }
    },

    showError(state, { payload }) {
      const { message } = payload;
      state.showErrorModal = true;
      state.errorMessage = message;
    },

    dismissError(state) {
      state.showErrorModal = false;
      state.errorMessage = '';
    },
  },
});

export const actions = { ...appSlice.actions };
export default appSlice.reducer;
